import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a65856b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Custom page name")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Custom page url")
], -1))
const _hoisted_3 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_4 = { class: "submit-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, { model: _ctx.customPageRef }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form_item, {
        ref: "name",
        name: "name"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_a_input, {
            type: "text",
            value: _ctx.customPageRef.name,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.customPageRef.name) = $event)),
            placeholder: "Custom page name",
            class: "ant-input"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "url",
        name: "url"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createVNode(_component_a_input, {
            type: "text",
            value: _ctx.customPageRef.url,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customPageRef.url) = $event)),
            placeholder: "Custom page url",
            class: "ant-input"
          }, null, 8, ["value"]),
          (!_ctx.isCustom(_ctx.customPageRef.url, _ctx.customPageRef.name))
            ? (_openBlock(), _createElementBlock("small", _hoisted_3, "Page name or url exists"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_button, {
              style: {"margin-right":"10px"},
              type: "default",
              onClick: _ctx.onCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              disabled: !_ctx.isCustom(_ctx.customPageRef.url, _ctx.customPageRef.name),
              type: "primary",
              onClick: _ctx.onSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.methodRef), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model"]))
}